module.exports = __webpack_public_path__ + "media/common/fonts/social/social-adf9912f2fc4f5b049e5c34ffa68dc39.woff";